import './style.scss'
import { useContext, useState } from 'react'
import ApiContext from 'src/provider/API/call-service'
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, Form, FormGroup, ScreenContainer } from "src/style"
import utility from "src/utils/utility"
import { CustomerInfo } from "src/component"
import { useNavigate } from 'react-router-dom'

const CustomerSearch = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const [search, setSearch] = useState('')

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault();
        const response = await API.searchUser(search)
        if (response) navigate('/customer-support/customer-data')
    }

    return (
        <>
            <ScreenContainer
                leftPadding='2.5' rightPadding='2.5'
                topPadding='1.5' bottomPadding='1.5'
            >
                <CustomContainer>
                    <CustomContainer topMargin="1.5">
                        <AppText textSize="2" fontWeight="600" color="#181D27" bottomMargin="0.7">Customer information</AppText>
                        <AppSpan color="#6F767C">View and manage crendly customers</AppSpan>
                    </CustomContainer>
                    <CustomContainer topMargin="14" className="customer-search-wrapper">
                        <FlexColumn 
                            width="52.9" height="41.9" borderColor="#E2E8F0"
                            radius="0.8" justifyContent="flex-start" topPadding="4"
                            bottomPadding="4" leftMargin="25"
                        >
                            <CustomContainer width="80" sizeUnit="%">
                                <AppText textSize="2" fontWeight="600" color="#27272E" bottomMargin="0.7">Customer details</AppText>
                                <AppSpan textSize="1.6" color="#27272E">Directly search and view customer details</AppSpan>
                                <Form topMargin="6" onSubmit={handleSubmit}>
                                    <FormGroup>
                                        <label>Search customer using</label>
                                        <input 
                                            placeholder='Name, phone number, email or BVN'
                                            name='search'
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            required
                                        />
                                    </FormGroup>
                                    <Button
                                        width='100' sizeUnit='%' borderColor='#4C6FFF' height='4.5'
                                        hoverBgColor='#ffffff' hoverColor='#4C6FFF'
                                    >
                                        Find customer
                                    </Button>
                                </Form>
                            </CustomContainer>
                        </FlexColumn>
                    </CustomContainer>
                </CustomContainer>
                
            </ScreenContainer>
        </>
    )
}

export default utility.routeData('customer-search', 'Customer Search', <CustomerSearch/>)